/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum EGroupBy {
    Unknown = 0,
    Agent = 1,
    BackupPolicy = 2,
}
